var render = function render() {
  var _vm$empresa;
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-dialog', {
    staticClass: "push-dialog",
    attrs: {
      "width": "310",
      "height": "310",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('div', {
    staticClass: "mx-auto icon-bell primary"
  })]), _c('v-card-text', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Somos o MeLembre, empresa parceira " + _vm._s((_vm$empresa = _vm.empresa) === null || _vm$empresa === void 0 ? void 0 : _vm$empresa.nome) + ". Trabalhamos para facilitar seu acesso a novidades e informações. Para ficar por dentro de tudo, aceita receber nossas notificações? ")]), _c('div', {
    staticClass: "card-action"
  }, [_c('v-checkbox', {
    staticClass: "ml-checkbox pt-0 mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "label": "Sim"
    },
    on: {
      "click": function click($event) {
        return _vm.aceitarNotificacoes();
      }
    }
  }), _c('v-checkbox', {
    staticClass: "ml-checkbox pt-0 mt-0 ml-2",
    attrs: {
      "hide-details": "",
      "label": "Não"
    },
    on: {
      "click": function click($event) {
        return _vm.showDialogPush(false);
      }
    }
  })], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };